module.exports = __webpack_public_path__ + "img/westim-logo.312db21a.jpg";